import { Suspense, Show, createEffect, createSignal, type ParentProps } from "solid-js"
import { createStore } from "solid-js/store"
import { ZdLeftSidebar } from "@/components/zd-left-sidebar"
import { DebugBar } from "@/components/debug-bar"
import { TabsInfoPopup } from "@/components/help-button"
import { ToastRegion, setV2Toast } from "@/utils/toast"
import { usePlatform } from "@/context/platform"

export default function ZdLayoutLeftRight(props: ParentProps) {
  const platform = usePlatform()
  const [state] = createStore({ debugTools: true })
  const [sidebarCollapsed, setSidebarCollapsed] = createSignal(false)

  createEffect(() => setV2Toast(true))

  return (
    <div
      class="relative isolate bg-v2-background-bg-deep flex-1 min-h-0 min-w-0 flex flex-row select-none [&_input]:select-text [&_textarea]:select-text [&_[contenteditable]]:select-text"
      style={{
        "padding-top": "env(safe-area-inset-top, 0px)",
        "padding-bottom": "env(safe-area-inset-bottom, 0px)",
      }}
    >
      <div
        class="zd-sidebar-wrapper"
        classList={{ "zd-sidebar-wrapper--collapsed": sidebarCollapsed() }}
      >
        <ZdLeftSidebar onCollapse={() => setSidebarCollapsed(true)} />
      </div>
      <Show when={sidebarCollapsed()}>
        <button
          type="button"
          class="zd-sidebar-expand-btn"
          onClick={() => setSidebarCollapsed(false)}
          aria-label="展开侧边栏"
        >
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" class="w-[16px] h-[16px]">
            <path d="M6 4L10 8L6 12" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </Show>
      <div class="flex-1 min-h-0 min-w-0 flex flex-col overflow-hidden">
        {/* Top bar: slogan + mount point for session-header V2 actions */}
        <div class="flex items-center gap-1 px-2 h-9 shrink-0">
          <span class="zd-topbar-slogan">
            智盾·SSAI 安全领域的能力工作台，一站式调用分析，攻防，鉴伪，情报，翻译能力
          </span>
          {/* Mount point for session-header V2 actions (status/review toggle) */}
          <div
            id="opencode-titlebar-right"
            class="flex items-center justify-end gap-1 shrink-0"
          />
        </div>
        <main class="flex-1 min-h-0 min-w-0 flex flex-col overflow-x-hidden">
          <Suspense>{props.children}</Suspense>
        </main>
      </div>
      {import.meta.env.DEV && state.debugTools && <DebugBar inline />}
      <TabsInfoPopup />
      <ToastRegion v2 />
    </div>
  )
}
